fx.ns("shared.renderers", class ShapeRenderer extends fx.Component{
    
	constructor(data, options)
	{
		super(data);

        this.itemWidth = options && options.itemWidth ? options.itemWidth : 45;
        this.itemHeight = options && options.itemHeight ? options.itemHeight : 50;
	}

	render()
	{
        return '<svg viewbox="0 0 35 35" class="ShapeRendererInner draggable" data-class="Shape" data-id="' + this.data.id + '" data-width="' + this.data.width + '" data-height="' + this.data.height + '" width="' + this.itemWidth + '" height="' + this.itemHeight + '">' +
                    '<g>'+
                        this.data.svg + 
                    '</g>'+
                '</svg>';
    }
    
   /* onDisplayUpdated()
    {
		super.onDisplayUpdated();

        if (this.find("#shape"))
        {
            this.find("#shape").setAttribute('width', Number(this.data.width) + "%");
            this.find("#shape").setAttribute('height', Number(this.data.height));

            this.find("#shape").setAttribute('r', Number(this.data.width));
            this.find("#shape").setAttribute('cx', Number(this.data.height));
            this.find("#shape").setAttribute('cy', Number(this.data.height));
        }

	}*/

    
    
    
});